import React from 'react'
import { Card, CardContent, CardHeader, Progress, Table, Td, Th, Tr } from '@/shared/ui'
import type { RelatorioV2Metrics } from '../utils/metrics'
import { formatInt, formatPct01 } from '../utils/format'

type RowDef = { key: keyof RelatorioV2Metrics; label: string }
const ROWS: RowDef[] = [
  { key: 'tp3Hit', label: 'Atingiu Alvo 3' },
  { key: 'tp2Hit', label: 'Atingiu Alvo 2' },
  { key: 'tp1Hit', label: 'Atingiu Alvo 1' },
  { key: 'stopOnly', label: 'Stop (sem alvo)' },
]

export default function OutcomeDistributionTable({ metrics }: { metrics: RelatorioV2Metrics }) {
  const total = Math.max(1, metrics.total || 0)

  return (
    <Card>
      <CardHeader className="text-sm font-medium">Níveis atingidos (não exclusivo)</CardHeader>
      <CardContent className="space-y-3">
        <div className="overflow-x-auto">
          <Table>
            <thead>
              <Tr>
                <Th>Métrica</Th>
                <Th className="text-right">Qtde</Th>
                <Th className="text-right">%</Th>
                <Th className="min-w-[180px]">Barra</Th>
              </Tr>
            </thead>
            <tbody>
              {ROWS.map((r) => {
                const c = Number((metrics as any)[r.key] || 0)
                const pct = c / total
                return (
                  <Tr key={String(r.key)}>
                    <Td>{r.label}</Td>
                    <Td className="text-right">{formatInt(c)}</Td>
                    <Td className="text-right">{formatPct01(pct)}</Td>
                    <Td>
                      <Progress value={pct * 100} />
                    </Td>
                  </Tr>
                )
              })}
            </tbody>
          </Table>
        </div>
        <div className="text-xs text-foreground/70">
          Observa��ǜo: Stop considera apenas quando nenhum alvo foi atingido; encerramentos por entry_missed contam como Alvo 3 (e por inclus��ǜo em 2 e 1).
        </div>
      </CardContent>
    </Card>
  )
}

